import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { DeleteParticipantRestrictivePracticeLabel } from '../mutations/deleteParticipantRestrictivePracticeLabel.mutation';
import type {
  DeleteParticipantRestrictivePracticeLabelMutation,
  DeleteParticipantRestrictivePracticeLabelMutationVariables,
} from '../types';

export const useDeleteParticipantRestrictivePracticeLabelMutation = (
  options?: MutationOptions<
    DeleteParticipantRestrictivePracticeLabelMutation,
    DeleteParticipantRestrictivePracticeLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantRestrictivePracticeLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
